import storage from '../../utils/storage';
import translate from '../../utils/webcomponents/translate';

const REGISTRATION_STORAGE_KEY = 'bnp.webinars';

const normalizeSlug = (slug) => (typeof slug === 'string' ? slug.trim() : '');

const getStoredSlugs = () => {
	try {
		const storedValue = storage.get(REGISTRATION_STORAGE_KEY);
		const slugs = storedValue.slugs || [];

		return slugs.filter((value) => value.length > 0);
	} catch (error) {
		console.error('Error accessing webinar registration storage:', error);
		return [];
	}
};

const saveSlugs = (slugs) => {
	try {
		storage.save(REGISTRATION_STORAGE_KEY, { slugs: [...new Set(slugs)] });
	} catch (error) {
		console.error('Error accessing webinar registration storage:', error);
	}
};

const storeRegistrationSlug = (slug) => {
	const normalizedSlug = normalizeSlug(slug);
	if (!normalizedSlug) {
		return;
	}

	const existingSlugs = getStoredSlugs();

	if (existingSlugs.includes(normalizedSlug)) {
		return;
	}

	saveSlugs([...existingSlugs, normalizedSlug]);
};

const isWebinarRegistered = (slug) => {
	const normalizedSlug = normalizeSlug(slug);
	if (!normalizedSlug) {
		return false;
	}

	return getStoredSlugs().includes(normalizedSlug);
};

const updatePageAfterRegistration = (slug, embedCode, status) => {
	storeRegistrationSlug(slug);

	// Registered and upcoming
	if (status === 'Upcoming') {
		const statusContainer = document.querySelector('[data-webinar-registration-status]');
		if (statusContainer) {
			const messageText = translate(
				'webinarcontent',
				'subscriptionSuccessMessage',
				'You are already registered. Keep an eye on your email, for the webinar link.',
			);

			statusContainer.innerHTML = '';

			const statusMessage = document.createElement('x-message');
			statusMessage.setAttribute('modifier', 'positive');
			statusMessage.setAttribute('icon', 'checkmark');
			statusMessage.message = messageText;

			statusContainer.appendChild(statusMessage);
		}
		return;
	}

	// Registered and has embed code to show
	const mediaContainer = document.querySelector('[data-webinar-media-container]');

	if (embedCode && mediaContainer) {
		const elementsToRemove = document.querySelectorAll('.webinar-placeholder, [data-webinar-register-button]');
		elementsToRemove.forEach((el) => el.remove());

		mediaContainer.innerHTML = `<div class="webinar-video">${embedCode}</div>`;
	}
};

export { isWebinarRegistered, updatePageAfterRegistration };
